import { toast } from 'react-hot-toast'; // Library to display toast notifications
import React, { useState, useEffect } from 'react';
import { useAuth } from '@context/AuthContext'; // Custom hook to access authentication and user data
import { setDoc, getDoc, doc, updateDoc } from 'firebase/firestore'; // Firestore functions for fetching and updating data
import { db } from '@root/firebase'; // Firebase Firestore database instance

/******************************************************************************
        Password Functions
******************************************************************************/

//Password Validation Check
//Checks for special characters, numbers, UpperCase and Length

export function passwordLength(password) {
  return password.length > 7; // This will return true or false directly
}

export function passwordLetterBoolean(password) {
  return /[A-Z]/.test(password); // Returns true if the password contains at least one uppercase letter
}

export function passwordNumBoolean(password) {
  return /\d/.test(password); // Checks if the string contains at least one digit
}

export function passwordSpecialCharBoolean(password) {
  const specialChars = '!@#$%^&*()-_=+[{]}\\|;:\'",<.>/?`~';
  const specialCharRegex = new RegExp(
    `[${specialChars.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')}]`
  );
  return specialCharRegex.test(password); // Checks if the string contains any special character
}

export function passwordMatch(password, password2) {
  return password === password2;
}

/******************************************************************************
        Form Validation Functions
******************************************************************************/

//
//

export function validateEmailFormat(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email format regex
  return emailRegex.test(email);
}

/******************************************************************************
        Address Functions
******************************************************************************/

export const addProductFields = [
  { id: 'name', label: 'Product Name', col: 4, type: 'text' },
  { id: 'category', label: 'Product Category', col: 4, type: 'select' },
  { id: 'subCategory', label: 'Product Sub Category', col: 4, type: 'select' },
  { id: 'price', label: 'Price', col: 4, type: 'number' },
  { id: 'discount', label: 'Discount %', col: 4, type: 'number' },
  { id: 'description', label: 'Description', col: 12, type: 'textarea' },
];

export const personalSocialMediaFields = [
  {
    id: 1,
    value: 'Facebook',
    icon: 'mdi mdi-facebook  text-muted font-size-20 me-2',
    variable: 'facebook',
  },
  {
    id: 2,
    value: 'TikTok',
    icon: 'mdi mdi-television  text-muted font-size-20 me-2',
    variable: 'tiktok',
  },
  {
    id: 3,
    value: 'Instagram',
    icon: 'mdi mdi-instagram  text-muted font-size-20 me-2',
    variable: 'instagram',
  },
  {
    id: 4,
    value: 'LinkedIn',
    icon: 'mdi mdi-linkedin  text-muted font-size-20 me-2',
    variable: 'linkedIn',
  },
  {
    id: 5,
    value: 'YouTube',
    icon: 'mdi mdi-youtube  text-muted font-size-20 me-2',
    variable: 'youTube',
  },
  {
    id: 6,
    value: 'Telegram',
    icon: 'mdi mdi-telegram  text-muted font-size-20 me-2',
    variable: 'telegram',
  },
];

export const personalInformationFields = [
  {
    id: 1,
    value: 'Occupation',
    icon: 'mdi mdi-facebook  text-muted font-size-20 me-2',
    variable: 'occupation',
  },
  {
    id: 2,
    value: 'Date of Birth',
    icon: 'mdi mdi-television  text-muted font-size-20 me-2',
    variable: 'dob',
    type: 'date',
  },
  {
    id: 3,
    value: 'Alt. Email',
    icon: 'mdi mdi-instagram  text-muted font-size-20 me-2',
    variable: 'altEmail',
  },
  {
    id: 4,
    value: 'Mobile',
    icon: 'mdi mdi-linkedin  text-muted font-size-20 me-2',
    variable: 'mobile',
  },
  {
    id: 5,
    value: 'Alt. Mobile',
    icon: 'mdi mdi-youtube  text-muted font-size-20 me-2',
    variable: 'altMobile',
  },
];

export const companyInformationFields = [
  {
    id: 1,
    value: 'Website',
    icon: 'mdi mdi-facebook  text-muted font-size-20 me-2',
    variable: 'website',
  },
  {
    id: 2,
    value: 'No of Employees',
    icon: 'mdi mdi-television  text-muted font-size-20 me-2',
    variable: 'employees',
    type: 'select',
  },
  {
    id: 3,
    value: 'Industry',
    icon: 'mdi mdi-instagram  text-muted font-size-20 me-2',
    variable: 'industry',
    type: 'select',
  },
  {
    id: 4,
    value: 'Presence',
    icon: 'mdi mdi-linkedin  text-muted font-size-20 me-2',
    variable: 'opModel',
    type: 'select',
  },
  {
    id: 5,
    value: 'Telephone',
    icon: 'mdi mdi-youtube  text-muted font-size-20 me-2',
    variable: 'telephone',
  },
  {
    id: 3,
    value: 'Email',
    icon: 'mdi mdi-instagram  text-muted font-size-20 me-2',
    variable: 'email',
  },
];

export const participantOpModel = [
  { value: '1', label: 'Online Only' },
  { value: '2', label: 'Physical Stores' },
  { value: '3', label: 'Online and Physical Stores' },
];

export const participantNoofEmployess = [
  { value: '1', label: 'Under 25' },
  { value: '2', label: '25 - 50' },
  { value: '3', label: '100 - 500' },
  { value: '4', label: '500 - 1000' },
  { value: '5', label: '1000 - 10k' },
  { value: '6', label: '10k - 50k' },
  { value: '7', label: '50k +' },
];

export const participantIndustryVerticals = [
  { value: '1', label: 'Distributor' },
  { value: '2', label: 'Supplier' },
  { value: '3', label: 'Manufacturer' },
  { value: '4', label: 'Nutrition Food' },
  { value: '5', label: 'Nutrition Other' },
  { value: '6', label: 'Product Novelty' },
  { value: '7', label: 'Product Large' },
  { value: '8', label: 'Medical Pharma' },
  { value: '9', label: 'Medical Veterinarian' },
  { value: '10', label: 'Veterinarian Service' },
  { value: '11', label: 'Medical Hospital' },
  { value: '12', label: 'Medical Other' },
  { value: '13', label: 'Service Grooming' },
  { value: '14', label: 'Service Kennel' },
  { value: '15', label: 'Service Walker' },
  { value: '16', label: 'Service Test' },
  { value: '17', label: 'Service Breeder' },
  { value: '18', label: 'Service Adoption' },
  { value: '19', label: 'Service Training' },
  { value: '20', label: 'Service Other' },
  { value: '21', label: 'Association/Member' },
  { value: '22', label: 'Periodical/News' },
  { value: '23', label: 'Group - Breed' },
  { value: '24', label: 'Charity' },
];

export const addressFields = [
  { id: 'street', label: 'Street Address', col: 12, type: 'text' },
  { id: 'city', label: 'City', col: 6, type: 'text' },
  { id: 'region', label: 'Region/County', col: 6, type: 'text' },
  { id: 'country', label: 'Country', col: 6, type: 'text' },
  { id: 'zip', label: 'Zip/Post Code', col: 6, type: 'text' },
];

export const questionCategories = [
  { value: 'Food', label: 'Food' },
  { value: 'Behaviour', label: 'Behaviour' },
  { value: 'Medical', label: 'Medical' },
  { value: 'Clothing/Accessories', label: 'Clothing/Accessories' },
  { value: 'Other', label: 'Other' },
];

export const myCalendarColors = [
  { id: 1, value: 'Appointment', color: 'success' },
  { id: 2, value: 'Anniversay', color: 'info' },
  { id: 3, value: 'Reminder', color: 'warning' },
  { id: 4, value: 'Event', color: 'danger' },
  { id: 5, value: 'Follow Up', color: 'secondary' },
  { id: 6, value: 'Urgent', color: 'primary' },
  { id: 7, value: 'Notification', color: 'soft-danger' },
  { id: 8, value: 'Record Of', color: 'soft-primary' },
];

export const myMemorialMenu = [
  {
    id: 1,
    value: 'My Memorials',
    icon: 'mdi mdi-star-outline  text-muted font-size-20 me-2',
    link: 'myMemorial',
  },
  {
    id: 2,
    value: 'My Favorites',
    icon: 'mdi mdi-star-outline  text-muted font-size-20 me-2',
    link: 'myFavorites',
  },
];

export const dashboardMenu = [
  {
    id: 1,
    value: 'SMART Memorial',
    icon: 'mdi mdi-grave-stone  text-muted font-size-20 me-2',
    link: '/app/memorial',
  },
  {
    id: 2,
    value: 'SMART Profile',
    icon: 'mdi mdi-dog  text-muted font-size-20 me-2',
    link: '/app/profile',
  },
  {
    id: 2,
    value: 'SMART Calendar',
    icon: 'mdi mdi-calendar  text-muted font-size-20 me-2',
    link: '/app/calendar',
  },
  {
    id: 2,
    value: 'SMART Files',
    icon: 'mdi mdi-dog-side  text-muted font-size-20 me-2',
    link: '/app/dog',
  },
  {
    id: 2,
    value: 'SMART Controls',
    icon: 'mdi mdi-tune-vertical-variant text-muted font-size-20 me-2',
    link: '/app/profile',
  },
  {
    id: 2,
    value: 'SMART Library',
    icon: 'mdi mdi-book-open-variant  text-muted font-size-20 me-2',
    link: '/app/library',
  },
];

export const supportMenu = [
  {
    id: 1,
    value: 'Coping With Loss',
    icon: 'mdi mdi-star-outline  text-muted font-size-20 me-2',
    link: 'myMemorial',
  },
  {
    id: 2,
    value: 'Healing Rituals',
    icon: 'mdi mdi-star-outline  text-muted font-size-20 me-2',
    link: 'myFavorites',
  },
  {
    id: 3,
    value: 'Wellness Webinars',
    icon: 'mdi mdi-star-outline  text-muted font-size-20 me-2',
    link: 'myMemorial',
  },
  {
    id: 4,
    value: 'Adoption',
    icon: 'mdi mdi-star-outline  text-muted font-size-20 me-2',
    link: 'myFavorites',
  },
];

export const createMemorialMenu = [
  {
    id: 1,
    value: 'Memorial',
    icon: 'mdi mdi-account-multiple text-muted font-size-20 me-2',
    link: 'createMemorial',
  },
  {
    id: 2,
    value: 'Birthday & Celebration',
    icon: 'mdi mdi-cake text-muted font-size-20 me-2',
    link: 'createMemorial',
  },
  {
    id: 3,
    value: 'Congrats & Praise',
    icon: 'mdi mdi-party-popper text-muted font-size-20 me-2',
    link: 'createMemorial',
  },
  {
    id: 4,
    value: 'Farewell',
    icon: 'mdi mdi-hand-left text-muted font-size-20 me-2',
    link: 'createMemorial',
  },
  {
    id: 5,
    value: 'Sympathy & Get Well',
    icon: 'mdi mdi-ambulance text-muted font-size-20 me-2',
    link: 'createMemorial',
  },
  {
    id: 6,
    value: 'Thank You',
    icon: 'mdi mdi-cards-heart text-muted font-size-20 me-2',
    link: 'createMemorial',
  },
  {
    id: 7,
    value: 'Welcome',
    icon: 'mdi mdi-hand text-muted font-size-20 me-2',
    link: 'createMemorial',
  },
  {
    id: 8,
    value: 'Service Anniversary',
    icon: 'mdi mdi-trophy-variant text-muted font-size-20 me-2',
    link: 'createMemorial',
  },
  {
    id: 9,
    value: 'Event',
    icon: 'mdi mdi-calendar-star text-muted font-size-20 me-2',
    link: 'createEvent',
  },
];

export const memorialMenu = [
  {
    id: 1,
    value: 'Search for Memorials',
    icon: 'mdi mdi-folder-search text-muted font-size-20 me-2',
    link: 'searchMemorial',
  },
  {
    id: 2,
    value: 'Community',
    icon: 'mdi mdi-account-heart text-muted font-size-20 me-2',
    link: 'community',
  },
  {
    id: 3,
    value: 'Charitable Donations',
    icon: 'mdi mdi-hand-heart text-muted font-size-20 me-2',
    link: 'memorialMenu',
  },
  {
    id: 4,
    value: 'Resource Centre',
    icon: 'mdi mdi-library-shelves text-muted font-size-20 me-2',
    link: 'memorialMenu',
  },
  {
    id: 5,
    value: 'Events',
    icon: 'mdi mdi-calendar-star text-muted font-size-20 me-2',
    link: 'memorialMenu',
  },
];

export const foodType = [
  { id: 1, value: 'Dry Kibble' },
  { id: 2, value: 'Wet Food' },
  { id: 3, value: 'Raw Diet' },
  { id: 4, value: 'Homemade' },
];

export const foodFrequency = [
  { id: 1, value: 'Morning' },
  { id: 2, value: 'Lunch' },
  { id: 3, value: 'Dinner' },
  { id: 4, value: 'Daily' },
  { id: 5, value: 'Weekly' },
];

export const treatmentType = [
  { id: 1, value: 'Preventative' },
  { id: 2, value: 'Curative' },
  { id: 3, value: 'Wellness' },
];

export const treatPurpose = [
  { id: 1, value: 'Training' },
  { id: 2, value: 'Dental Health' },
  { id: 3, value: 'Reward' },
];

export const frequency = [
  { id: 1, value: 'Monthly' },
  { id: 2, value: 'Annually' },
  { id: 3, value: 'As Needed' },
];

export const outcome = [
  { id: 1, value: 'Effective' },
  { id: 2, value: 'No Change' },
  { id: 3, value: 'Side Effects' },
];

export const effectiveness = [
  { id: 1, value: 'Very Effective' },
  { id: 2, value: 'Somewhat Effective' },
  { id: 3, value: 'Ineffective' },
];

export const insuranceType = [
  { id: 1, value: 'Accident Only' },
  { id: 2, value: 'Accident and Illness' },
  { id: 3, value: 'Comprehensive' },
];

// Forms for Vet, Groomer and Walkers
export const serviceFields = [
  { id: 'name', label: 'Name', col: 6 },
  { id: 'contactNumber', label: 'Contact Number', col: 6 },
  { id: 'email', label: 'Email', col: 12 },
  //{ id: "notneeded", label: "", col: 12, type: "address" },
];

export const serviceTables = [
  { id: 'name', label: 'Name' },
  { id: 'contactNumber', label: 'Contact Number' },
  { id: 'email', label: 'Email' },
];

export const addressTables = [
  { id: 'street', label: 'Street' },
  { id: 'city', label: 'City' },
  { id: 'zip', label: 'Zip' },
];

export const insuranceTables = [
  { id: 'provider', label: 'Provider' },
  { id: 'cover', label: 'Cover' },
  { id: 'premium', label: 'Premium' },
  { id: 'renewalDate', label: 'Renewal Date' },
];

export const insuranceFields = [
  {
    id: 'provider',
    label: 'Insurance Provider?',
    col: 6,
    type: 'text',
  },
  {
    id: 'cover',
    label: 'Insurance Type?',
    col: 6,
    type: 'select',
    options: insuranceType.map((val) => ({
      value: val.value,
      label: val.value,
    })),
  },
  { id: 'premium', label: 'Annual Premium', col: 6 },
  { id: 'renewalDate', label: 'Renewal Date', col: 6, type: 'date' },
  //{ id: "insuredDogs", label: "Select Insured Dogs?", col: 6, type: "multi-select", },
];

export const medicationTables = [
  { id: 'medication', label: 'Medication' },
  { id: 'purpose', label: 'Purpose' },
  { id: 'dosage', label: 'Dosage' },
  { id: 'effectiveness', label: 'Effectivenss' },
];

export const medicationFields = [
  { id: 'medication', label: 'Type of Medication?', col: 6, type: 'text' },
  {
    id: 'purpose',
    label: 'Medication Purpose?',
    col: 6,
    type: 'text',
  },
  { id: 'dosage', label: 'Medication Dosage?', col: 6, type: 'text' },
  {
    id: 'effectiveness',
    label: 'Effectiveness?',
    col: 6,
    type: 'select',
    options: effectiveness.map((val) => ({
      value: val.value,
      label: val.value,
    })),
  },
  { id: 'observations', label: 'Observations', col: 6, type: 'text' },
  //{ id: "medicatedDogs", label: "Select Medicated Dogs?", col: 6, type: "multi-select", },
];

export const treatmentTables = [
  { id: 'treatment', label: 'Treatment' },
  { id: 'type', label: 'Type' },
  { id: 'purpose', label: 'Purpose' },
  { id: 'frequency', label: 'Frequency' },
];

export const treatmentFields = [
  { id: 'treatment', label: 'Treatment?', col: 6, type: 'text' },
  {
    id: 'type',
    label: 'Treatment Type?',
    col: 6,
    type: 'select',
    options: treatmentType.map((val) => ({
      value: val.value,
      label: val.value,
    })),
  },
  {
    id: 'purpose',
    label: 'Treatement Purpose?',
    col: 6,
    type: 'text',
  },
  {
    id: 'frequency',
    label: 'Treatment Frequency?',
    col: 6,
    type: 'select',
    options: frequency.map((val) => ({ value: val.value, label: val.value })),
  },
  {
    id: 'outcome',
    label: 'Treatment Outcome?',
    col: 6,
    type: 'select',
    options: outcome.map((val) => ({ value: val.value, label: val.value })),
  },
  { id: 'observations', label: 'Observations', col: 6 },
  //{ id: "treatedDogs", label: "Select Treated Dogs?", col: 6, type: "multi-select", },
];

export const foodTables = [
  { key: 'type', label: 'type' },
  { key: 'brand', label: 'brand' },
  { key: 'frequency', label: 'frequency' },
  { key: 'dietary', label: 'dietary' },
];

export const foodFields = [
  {
    id: 'type',
    label: 'Food Type?',
    col: 6,
    type: 'select',
    options: foodType.map((val) => ({ value: val.value, label: val.value })),
  },
  { id: 'brand', label: 'Food Brand?', col: 6, type: 'text' },
  {
    id: 'frequency',
    label: 'Food Frequency?',
    col: 6,
    type: 'select',
    options: foodFrequency.map((val) => ({
      value: val.value,
      label: val.value,
    })),
  },
  { id: 'dietary', label: 'Dietary Needs?', col: 6, type: 'text' },
];

export const supplementTables = [
  { key: 'type', label: 'type' },
  { key: 'purpose', label: 'purpose' },
  { key: 'dosage', label: 'Dosage' },
  { key: 'effectiveness', label: 'Effectiveness' },
];

export const supplementFields = [
  { id: 'type', label: 'Type of supplement?', col: 6, type: 'text' },
  {
    id: 'purpose',
    label: 'supplement Purpose?',
    col: 6,
    type: 'text',
  },
  {
    id: 'dosage',
    label: 'supplement Dosage?',
    col: 6,
    type: 'text',
  },
  {
    id: 'effectiveness',
    label: 'supplement Effectiveness?',
    col: 6,
    type: 'select',
    options: effectiveness.map((val) => ({
      value: val.value,
      label: val.value,
    })),
  },
];

export const treatTables = [
  { key: 'type', label: 'type' },
  { key: 'brand', label: 'brand' },
  { key: 'purpose', label: 'purpose' },
  { key: 'frequency', label: 'frequency' },
];

export const treatFields = [
  { id: 'type', label: 'Type of Treat?', col: 6, type: 'text' },
  { id: 'brand', label: 'Treat Brand?', col: 6, type: 'text' },
  {
    id: 'purpose',
    label: 'Treat Purpose?',
    col: 6,
    type: 'select',
    options: treatPurpose.map((val) => ({
      value: val.value,
      label: val.value,
    })),
  },
  {
    id: 'frequency',
    label: 'Treat Frequency?',
    col: 6,
    type: 'select',
    options: foodFrequency.map((val) => ({
      value: val.value,
      label: val.value,
    })),
  },
];

export const alternativeTables = [
  { key: 'type', label: 'type' },
  { key: 'purpose', label: 'purpose' },
  { key: 'frequency', label: 'frequency' },
];

export const alternativeFields = [
  { id: 'type', label: 'Type of Treat?', col: 6, type: 'text' },
  { id: 'purpose', label: 'Treat purpose?', col: 6, type: 'text' },
  {
    id: 'frequency',
    label: 'Treat Frequency?',
    col: 6,
    type: 'select',
    options: foodFrequency.map((val) => ({
      value: val.value,
      label: val.value,
    })),
  },
];

export const accountServicesTabs = [
  { id: 'personalDetails', label: 'Personal Details' },
  { id: 'changePassword', label: 'Change password' },
  { id: 'security', label: 'Security' },
];

export const nutritionMenuTabs = [
  { id: 'food', label: 'Food Services' },
  { id: 'supplements', label: 'Supplements' },
  { id: 'treats', label: 'Treats' },
  { id: 'alternatives', label: 'Alternatives' },
];

export const propertyType = [
  { id: 1, value: 'Apartment' },
  { id: 2, value: 'House' },
  { id: 3, value: 'Town House' },
  { id: 4, value: 'Farm' },
  { id: 5, value: 'Caravan' },
];

export const dangersNearBy = [
  { id: 1, value: 'Pool' },
  { id: 2, value: 'Pond' },
  { id: 3, value: 'Highway' },
  { id: 4, value: 'Inner City' },
  { id: 5, value: 'High Rise' },
];

export const notificationOnOff = [
  {
    id: 'local',
    labels: 'Local',
    switch: 'warning',
    title: 'Geographic Location',
  },
  {
    id: 'regional',
    labels: 'Regional',
    switch: 'warning',
    title: 'Geographic Location',
  },
  {
    id: 'state',
    labels: 'State',
    switch: 'warning',
    title: 'Geographic Location',
  },
  {
    id: 'national',
    labels: 'National',
    switch: 'warning',
    title: 'Geographic Location',
  },
  {
    id: 'calendarReminders',
    labels: 'Reminders',
    switch: 'success',
    title: 'SMART Calendar',
  },
  {
    id: 'calendarEvents',
    labels: ' Events',
    switch: 'success',
    title: 'SMART Calendar',
  },
  {
    id: 'email',
    labels: 'Email',
    switch: 'success',
    title: 'SMART Calendar',
  },
  {
    id: 'smartNews',
    labels: 'Feature News',
    switch: 'primary',
    title: 'SMART News & Alerts',
  },
  {
    id: 'breakingNews',
    labels: 'Breaking News',
    switch: 'primary',
    title: 'SMART News & Alerts',
  },
  {
    id: 'assistNews',
    labels: 'Assist News',
    switch: 'primary',
    title: 'SMART News & Alerts',
  },
  {
    id: 'vetinarian',
    labels: 'Vetinarian',
    switch: 'info',
    title: 'SMART Services',
  },
  {
    id: 'careProvider',
    labels: 'Care Provider',
    switch: 'info',
    title: 'SMART Services',
  },
  {
    id: 'walkerSitter',
    labels: 'Walker/Sitter',
    switch: 'info',
    title: 'SMART Services',
  },
  {
    id: 'organisation',
    labels: 'Organisation',
    switch: 'info',
    title: 'SMART Services',
  },
  { id: 'breed', labels: 'Breed', switch: 'info', title: 'SMART Services' },
  {
    id: 'nutrition',
    labels: 'Nutrition',
    switch: 'info',
    title: 'SMART Services',
  },
  {
    id: 'medical',
    labels: 'Medical',
    switch: 'info',
    title: 'SMART Services',
  },
  {
    id: 'view30',
    labels: '30 Days View',
    switch: 'danger',
    title: 'SMART Settings',
  },
  {
    id: 'viewDelete',
    labels: 'View Until Delete',
    switch: 'danger',
    title: 'SMART Settings',
  },
  {
    id: 'fowardToEmail',
    labels: 'Send to Email',
    switch: 'danger',
    title: 'SMART Settings',
  },
  {
    id: 'profilePrivate',
    labels: 'Make Profile Private',
    switch: 'danger',
    title: 'SMART Settings',
  },
];

export const languages = [
  { value: 'en', label: 'English' },
  { value: 'es', label: 'Spanish' },
  { value: 'fr', label: 'French' },
  { value: 'de', label: 'German' },
  { value: 'zh', label: 'Chinese' },
  { value: 'ja', label: 'Japanese' },
  { value: 'ko', label: 'Korean' },
  { value: 'ar', label: 'Arabic' },
  { value: 'ru', label: 'Russian' },
  { value: 'pt', label: 'Portuguese' },
  { value: 'it', label: 'Italian' },
  { value: 'hi', label: 'Hindi' },
  { value: 'bn', label: 'Bengali' },
  { value: 'ur', label: 'Urdu' },
  { value: 'tr', label: 'Turkish' },
  { value: 'vi', label: 'Vietnamese' },
  { value: 'th', label: 'Thai' },
  { value: 'nl', label: 'Dutch' },
  { value: 'sv', label: 'Swedish' },
  { value: 'da', label: 'Danish' },
  { value: 'fi', label: 'Finnish' },
  { value: 'no', label: 'Norwegian' },
  { value: 'pl', label: 'Polish' },
  { value: 'uk', label: 'Ukrainian' },
  { value: 'el', label: 'Greek' },
  { value: 'he', label: 'Hebrew' },
  { value: 'id', label: 'Indonesian' },
  { value: 'ms', label: 'Malay' },
  { value: 'fa', label: 'Persian' },
  { value: 'sw', label: 'Swahili' },
];

export const timezones = [
  { value: 'Pacific/Midway', label: '(GMT-11:00) Midway Island' },
  { value: 'Pacific/Honolulu', label: '(GMT-10:00) Hawaii' },
  { value: 'America/Anchorage', label: '(GMT-09:00) Alaska' },
  {
    value: 'America/Los_Angeles',
    label: '(GMT-08:00) Pacific Time (US & Canada)',
  },
  { value: 'America/Denver', label: '(GMT-07:00) Mountain Time (US & Canada)' },
  { value: 'America/Phoenix', label: '(GMT-07:00) Arizona' },
  { value: 'America/Chicago', label: '(GMT-06:00) Central Time (US & Canada)' },
  {
    value: 'America/New_York',
    label: '(GMT-05:00) Eastern Time (US & Canada)',
  },
  { value: 'America/Caracas', label: '(GMT-04:00) Caracas' },
  { value: 'America/Santiago', label: '(GMT-04:00) Santiago' },
  { value: 'America/Sao_Paulo', label: '(GMT-03:00) Brasilia' },
  { value: 'Atlantic/South_Georgia', label: '(GMT-02:00) Mid-Atlantic' },
  { value: 'Atlantic/Azores', label: '(GMT-01:00) Azores' },
  { value: 'Europe/London', label: '(GMT+00:00) London' },
  { value: 'Europe/Paris', label: '(GMT+01:00) Paris' },
  { value: 'Europe/Berlin', label: '(GMT+01:00) Berlin' },
  { value: 'Europe/Athens', label: '(GMT+02:00) Athens' },
  { value: 'Africa/Cairo', label: '(GMT+02:00) Cairo' },
  { value: 'Asia/Jerusalem', label: '(GMT+02:00) Jerusalem' },
  { value: 'Asia/Riyadh', label: '(GMT+03:00) Riyadh' },
  { value: 'Europe/Moscow', label: '(GMT+03:00) Moscow' },
  { value: 'Asia/Dubai', label: '(GMT+04:00) Dubai' },
  { value: 'Asia/Kabul', label: '(GMT+04:30) Kabul' },
  { value: 'Asia/Karachi', label: '(GMT+05:00) Islamabad, Karachi' },
  { value: 'Asia/Kolkata', label: '(GMT+05:30) Mumbai, Kolkata, Chennai' },
  { value: 'Asia/Kathmandu', label: '(GMT+05:45) Kathmandu' },
  { value: 'Asia/Dhaka', label: '(GMT+06:00) Dhaka' },
  { value: 'Asia/Bangkok', label: '(GMT+07:00) Bangkok' },
  { value: 'Asia/Shanghai', label: '(GMT+08:00) Beijing, Shanghai' },
  { value: 'Asia/Tokyo', label: '(GMT+09:00) Tokyo' },
  { value: 'Australia/Sydney', label: '(GMT+10:00) Sydney' },
  { value: 'Pacific/Noumea', label: '(GMT+11:00) New Caledonia' },
  { value: 'Pacific/Auckland', label: '(GMT+12:00) Auckland' },
  { value: 'Pacific/Tongatapu', label: '(GMT+13:00) Tonga' },
];

export const personalDetailsFields = [
  { id: 'name', label: 'Full Name', col: 6, type: 'text' },
  { id: 'dob', label: 'Date of Birth', col: 6, type: 'date' },
  { id: 'occupation', label: 'Occupation', col: 6, type: 'text' },
  { id: 'contact', label: 'Contact #', col: 6, type: 'text' },
  {
    id: 'secondaryContact',
    label: 'Alternative Contact #',
    col: 6,
    type: 'text',
  },
  { id: 'website', label: 'Website', col: 6, type: 'text' },
  { id: 'altEmail', label: 'Alternative Email', col: 6, type: 'text' },
  {
    id: 'preferredLanguage',
    label: 'Preferred Language',
    col: 6,
    type: 'select',
    options: languages.map((val) => ({ value: val.value, label: val.value })),
  },
  {
    id: 'timezone',
    label: 'Timezone',
    col: 6,
    type: 'select',
    options: timezones.map((val) => ({ value: val.value, label: val.value })),
  },
  { id: 'about', label: 'About', col: 12, type: 'textarea' },
];
